export default __webpack_public_path__ + "static/media/e-mail.25586e0f.svg";